export default __webpack_public_path__ + "static/media/Accelerons2018.f247f925.png";